import Select from 'react-select';
/**
 * WordPress dependencies
 */
const { useState } = wp.element;
const { useSelect } = wp.data;

const TaxonomySelect = (props) => {
	const { postType } = props;

	const { taxonomies, isRequesting } = useSelect(
		(select) => {
			const postTypeObject = select('core').getPostType(postType);
			const taxonomies = postTypeObject?.taxonomies?.map((tax) => ({ label: tax, value: tax }));
			const isRequesting = select('core/data').isResolving('core', 'getPostType', [postType]);

			return { taxonomies, isRequesting };
		},
		[postType]
	);

	return (
		<div>
			<Select classNamePrefix='conditional-blocks-select' className='conditional-blocks-select-container' isSearchable isLoading={isRequesting} options={taxonomies} {...props} />
		</div>
	);
};

export default TaxonomySelect;
